import api from "./api";

export const checkAccess = async (
  token: string,
  route: string,
  userType: string,
): Promise<boolean> => {
  try {

    // 2️⃣ Agora faz o POST normalmente (sem recriar a instância)
    const response = await api.post(
      "/check-access",
      { route, role: userType },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.status === 200;

  } catch {
    return false;
  }
};
